import { Injectable } from '@angular/core';
import {
	CartesianScaleTypeRegistry,
	ChartTypeRegistry,
	FontSpec,
	LegendOptions,
	PointStyle,
	ScaleOptionsByType,
	TooltipOptions
} from 'chart.js';

@Injectable({
	providedIn: 'root'
})
export class ChartConfigService {
	getTooltipConfig(
		type: 'percent' | 'dollar' | 'default' = 'default'
	): Partial<TooltipOptions> {
		return <any>{
			position: 'nearest',
			axis: 'xy',
			backgroundColor: '#ffffff',
			bodyColor: '#121212',
			yAlign: 'bottom',
			xAlign: 'center',
			callbacks: {
				title: () => null,
				beforeLabel: item => {
					return item.label;
				},
				label: item => {
					if (type === 'percent') {
						return `${item.raw as number}%`;
					} else if (type === 'dollar') {
						return `$${item.raw as number}`;
					} else {
						return `${item.raw as number}`;
					}
				}
			},
			displayColors: false
		};
	}

	getScalesConfig(offset: boolean = false): Partial<{
		[p: string]: ScaleOptionsByType<keyof CartesianScaleTypeRegistry>;
	}> {
		return <any>{
			x: {
				offset: offset,
				border: {
					dash: [5, 5],
					color: '#B7D3F6',
					display: true
				},
				grid: {
					display: false
				}
			},
			y: {
				beginAtZero: true,
				border: {
					dash: [5, 5],
					color: '#B7D3F6'
				},
				grid: {
					color: '#B7D3F6'
				}
			}
		};
	}

	getLegendConfig<T extends keyof ChartTypeRegistry>(): Partial<
		LegendOptions<T>
	> {
		return <any>{
			position: 'bottom',
			align: 'start',
			labels: {
				pointStyle: 'circle' as PointStyle,
				textAlign: 'left'
			}
		};
	}

	getFontConfig(): Partial<Partial<FontSpec>> {
		return <any>{
			family: 'Gilroy'
		};
	}
}
